<template>
  <div>
    <please-wait-modal/>
    <profile
      v-show="!is_loading"
      :data="data_user"
      :is_edited="is_edited"
      @on-save="save"
      @on-change-publish="change_publish"
      @on-bypass-otp="bypass_otp"
      @on-bypass-verify="bypass_verify"
      @on-force-login="force_login"
      @on-suspend="suspend"
      @on-complete-signup="complete_signup"/>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import profile from '@/pages/user/user_component/profile'
import table_skeleton from '@/layout/table_skeleton'
import SkeletonBox from '@/layout/skeleton'

export default {
  components:{
    profile,
    'please-wait-modal': please_wait_modal,
    'table-skeleton': table_skeleton,
    'skeleton-box': SkeletonBox,
  },
  props: ['data_user1', 'is_loading', 'is_edited'],
  data(){
    return{
      data_user: {
        arr_point: [],
        arr_picture: [],
        arr_work_at: [],
        arr_skill: [],
        arr_online_test_result: [],
        arr_contract: [],
        type: {
          name: ''
        },
      },
    }
  },
  watch: {
    data_user1(val){
      if(val.id != null)
        this.get_data()
    }
  },
  created(){
    if(this.data_user.id != null)
      this.get_data()
  },
  methods: {
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){

      var data_user = JSON.parse(JSON.stringify(this.data_user1))
      // console.log(this.data_user1.document)
      data_user.reference_by = this.data_user1.reference_by != null ? this.data_user1.reference_by.name : 'None'
      data_user.rating = this.data_user1.average_rating
      data_user.total_kontrak = this.data_user1.total_contract != null ? this.data_user1.total_contract : 0
      data_user.id_card = this.data_user1.document.length > 0 ? base_url+'/images/document?file_name='+this.data_user1.document[0].file_name : ''
      data_user.birth_date = moment(this.data_user1.birth_date).format('DD MMMM YYYY')
      data_user.arr_point = this.data_user1.point
      data_user.arr_picture = this.data_user1.photo_list
      var arr_work_at = []
      for(let x in this.data_user1.work_at)
        arr_work_at.push(this.data_user1.work_at[x].city)
      data_user.arr_work_at = arr_work_at
      var arr_skill = []
      for(let x in this.data_user1.skill)
        arr_skill.push(this.data_user1.skill[x].skill)
      data_user.arr_skill = arr_skill
      data_user.arr_online_test_result = this.data_user1.online_test
      data_user.arr_contract = this.data_user1.contract
      data_user.phone_number = this.data_user1.phone
      data_user.requested_price = this.data_user1.requested_price.toLocaleString()
      data_user.birth_place = this.data_user1.birth_place_id
      data_user.marital_status = this.data_user1.marital_status_id
      data_user.tribes = this.data_user1.tribe_id
      data_user.blood_type = this.data_user1.blood_type_id
      data_user.religion = this.data_user1.religion_id
      data_user.education = this.data_user1.education_id
      data_user.city = this.data_user1.city_id
      data_user.helper_sub_category = this.data_user1.helper_sub_category_id
			console.log(data_user)
      this.data_user = data_user
    },
    async change_publish(is_publish){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id
        data.is_publish = this.data_user.is_publish == 1 ? 0 : 1

        var response = await axios.put(base_url+'/user/publish',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async bypass_otp(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.put(base_url+'/user/bypass-otp',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async bypass_verify(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.put(base_url+'/user/bypass-verify',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async force_login(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.post(base_url+'/user/force-login',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async suspend(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.put(base_url+'/user/suspend',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    async complete_signup(){
      try{
        $('#please_wait_modal').modal('show')

        var data = {}
        data.id = this.data_user.id

        var response = await axios.put(base_url+'/user/complete-signup',data)

        setTimeout(() => {
          $('#please_wait_modal').modal('hide')
        },500)

        var response_data = response.data
        if(response_data.status == "success"){
          this.$emit('on-get-data')
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    save(data_user){
      this.$emit('on-save',data_user)
    }
  }
}
</script>
